import { Routes } from '@angular/router';

// modal routes only work at the root level...

export const employeeSalaryAndRatesModalRoutes: Routes = [
  {
    path: 'employee/salary-details',
    outlet: 'tertiary-modal',
    loadChildren: () => import('../employees/employee-details/employee-salary-details.module').then((m) => m.EmployeeSalaryDetailsModule)
  },
  {
    path: 'employee/rate-details',
    outlet: 'tertiary-modal',
    loadChildren: () => import('../employees/employee-details/employee-rate-details.module').then((m) => m.EmployeeRateDetailsModule)
  }
];

export const employeesModalRoutes: Routes = [
  ...employeeSalaryAndRatesModalRoutes,
  {
    path: 'employee-edit',
    outlet: 'secondary-modal',
    loadChildren: () =>
      import('../employees/employee-details/employee-edit-section/employee-edit-section-routing.module').then(
        (m) => m.EmployeeEditSectionRoutingModule
      )
  },
  {
    path: 'employee/holiday-entitlement-details',
    outlet: 'tertiary-modal',
    loadChildren: () =>
      import('../employees/employee-details/holiday-entitlement-routing.module').then((m) => m.HolidayEntitlementRoutingModule)
  },
  {
    path: 'employee/voluntary-deduction-modal',
    outlet: 'tertiary-modal',
    loadChildren: () =>
      import('../employees/employee-details/deductions-loans/voluntary-deductions/voluntary-deductions-routing.module').then(
        (m) => m.VoluntaryDeductionsRoutingModule
      )
  },
  {
    path: 'employee/work-pattern',
    outlet: 'tertiary-modal',
    loadChildren: () => import('../employees/employee-details/employee-work-pattern.module').then((m) => m.EmployeeWorkPatternModule)
  },
  {
    path: 'employee/occupational-sick-scheme',
    outlet: 'tertiary-modal',
    loadChildren: () =>
      import('../employees/employee-details/employee-occupational-sick-scheme.module').then((m) => m.EmployeeOccupationalSickSchemeModule)
  },
  {
    path: 'employee/dynamic-costing-details',
    outlet: 'secondary-modal',
    loadChildren: () => import('../employees/employee-details/employee-costing-details.module').then((m) => m.EmployeeCostingDetailsModule)
  },
  {
    path: 'employee/position-details',
    outlet: 'tertiary-modal',
    loadChildren: () =>
      import('../employees/employee-details/employee-position-details.module').then((m) => m.EmployeePositionDetailsModule)
  },
  {
    path: 'employee/inactive-position-details',
    outlet: 'secondary-modal',
    loadChildren: () =>
      import('../employees/employee-details/employee-inactive-position-details.module').then((m) => m.EmployeeInactivePositionDetailsModule)
  },
  {
    path: 'employee/pension-contribution',
    outlet: 'modal',
    loadChildren: () =>
      import('../employees/employee-details/pensions/employee-pension-contribution.module').then((m) => m.EmployeePensionContributionModule)
  },
  {
    path: 'employee/opt-in-join-request',
    outlet: 'modal',
    loadChildren: () =>
      import('../employees/employee-details/pensions/employee-opt-in-join-request.module').then((m) => m.EmployeeOptInJoinRequestModule)
  },
  {
    path: 'employee/opt-in-by-request',
    outlet: 'modal',
    loadChildren: () =>
      import('../employees/employee-details/pensions/employee-opt-in-by-request.module').then((m) => m.EmployeeOptInByRequestModule)
  },

  {
    path: 'employee/spine-point-details',
    outlet: 'tertiary-modal',
    loadChildren: () =>
      import('../employees/employee-details/employee-spine-point-details.module').then((m) => m.EmployeeSpinePointDetailsModule)
  },
  {
    path: 'employees',
    outlet: 'modal',
    loadChildren: () => import('../employees/new-starters/new-starters.module').then((m) => m.NewStartersModule)
  },

  {
    path: 'employee-invitation-details',
    outlet: 'modal',
    loadChildren: () =>
      import('@security/users/users-hub/invitations/invites/employee-invitation-details-dialog/employee-invitation-details-dialog.module').then(
        (m) => m.EmployeeInvitationDetailsDialogModule
      )
  },
  {
    path: 'employee-account-details',
    outlet: 'modal',
    loadChildren: () =>
      import('@security/users/users-hub/users-grid/employee-account-details-modal/employee-account-details-modal.module').then(
        (m) => m.EmployeeAccountDetailsModalModule
      )
  },
  {
    path: 'new-starter-confirmation',
    outlet: 'modal',
    loadChildren: () =>
      import('./new-starters/new-starter-wizard/confirmation/new-starter-confirmation-modal.module').then(
        (m) => m.NewStarterConfirmationModalModule
      )
  },
  {
    path: 'employee/payment-details',
    outlet: 'tertiary-modal',
    loadChildren: () => import('../employees/employee-details/payment-details.module').then((m) => m.EmployeePaymentDetailsModule)
  }
];
